// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3ctxI","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3N9Ye"};